import Transition from 'semantic-ui-react/dist/es/modules/Transition';
import './Transition.css';

export default Transition;
